import React from 'react';
import useMediaQuery from '../../../hooks/useMediaQuery';
import styles from './AppLayout.module.css';

// The breakpoint the two layouts switch at, kept in step with the media
// queries in AppLayout.module.css.
const DESKTOP_QUERY = '(min-width: 1024px)';

// Only the layout that is actually on screen is rendered. Rendering `children`
// into both containers and hiding one with CSS mounted the whole app twice:
// every page ran its effects and fired its requests twice, the hidden copy
// drifted to its own stale state, and printing emitted both — the report came
// out preceded by a full copy of the page in its default view.
const AppLayout = ({ children }) => {
	const isDesktop = useMediaQuery(DESKTOP_QUERY);

	return (
		<div className={styles.layout}>
			<div className={isDesktop ? styles.desktopLayout : styles.mobileLayout}>
				{children}
			</div>
		</div>
	);
};

export default AppLayout;
